import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const PartnerProductSalesReport = lazyWithRetry(() => import(/* webpackChunkName: "PartnerProductSalesReport" */'../../component/PartnerOfficeReports/PartnerProductSalesReport'))

const PartnerProductSalesReportPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<PartnerProductSalesReport />
		</Suspense>
	)
})

PartnerProductSalesReportPage.displayName = 'PartnerProductSalesReportPage'
export default PartnerProductSalesReportPage
